import {Component} from '@angular/core';

@Component({
    selector: 'vui-panels',
    templateUrl: './panels.component.html',
    styleUrls: ['./panels.component.scss']
})
export class PanelsComponent {

}
